import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import EnquiryModal from "./EnquiryModal";
// import "./_AboutUs.scss"; // Ensure this matches your actual css file path

const AboutUs = () => {
    const [showModal, setShowModal] = useState(false); // <--- ADDED STATE
  return (
    <>
      <Header />

      <div className="about-us-page">
        {/* Banner Section */}
        <section className="about-banner">
          <div className="banner-overlay"></div>
          <div className="banner-content">
            <h1>Empowering Insurance Professionals</h1>
            <p>
              Your trusted partner in managing policies, clients, and growth
              seamlessly.
            </p>
            <button className="cta-button" onClick={() => setShowModal(true)}>Book a Demo</button>
          </div>
        </section>

        {/* About Us Content Section */}
        <section className="about-content-wrapper">
          <div className="container">
            <div className="section-title">
              <h2>About Us</h2>
            </div>

            <div className="content-grid">
              {/* Left Side: Text Content */}
              <div className="text-content">
                <h2>Stop tracking policies manually. Start managing them intelligently.</h2>
                <p>
                  <strong>PolicySaath</strong> was created to simplify the daily work of insurance professionals. Insurance agents manage multiple tasks, including customer data, policy details, renewals, follow-ups, and commissions.
                </p>
                <p>
                  Built for insurance agents and organizations, PolicySaath lets you import policies in bulk, add new records quickly, group families under one ID, track premiums due/collected, and stay on top of renewals with notifications. Access everything from a clean dashboard, filter by company or category, and export reports anytime.
                </p>
              </div>

              {/* Right Side: Video */}
              <div className="video-content">
                <div className="video-wrapper">
                  <iframe
                    width="315"
                    height="360"
                    src="https://www.youtube.com/embed/v20sV9bkHHc"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            </div>

            <div className="text-content">
              <p className="highlight-text mt-4">
                PolicySaath is not just software. It’s your digital partner in
                building a more organized, efficient, and successful insurance
                business.
              </p>
            </div>
          </div>
        </section>

        {/* Mission & Vision Section */}
        <section className="mission-vision-section pt-0">
          <div className="container">
            <h2 className="text-center border-bottom p-3 mb-4">What we Serve</h2>
            <div className="mv-grid">

              {/* Mission Card */}
              <div className="mv-card">
                <div className="card-image">
                  <img
                    src="https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2070&auto=format&fit=crop"
                    alt="Our Mission Team"
                  />
                </div>
                <div className="card-content">
                  <h3>Our Mission</h3>
                  <p>
                    Our mission is to simplify the day-to-day work of insurance agents
                    by providing a reliable, easy-to-use digital platform. We aim to
                    reduce manual effort, improve organization, and help agents manage
                    their customers and policies with confidence. By doing this, we
                    help insurance professionals focus on what truly matters: serving
                    clients better and growing their business.
                  </p>
                </div>
              </div>

              {/* Vision Card */}
              <div className="mv-card">
                <div className="card-image">
                  <img
                    src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=2070&auto=format&fit=crop"
                    alt="Future Vision"
                  />
                </div>
                <div className="card-content">
                  <h3>Our Vision</h3>
                  <p>
                    Our vision is to become India’s most trusted digital partner for
                    insurance agents. We want to empower every insurance professional,
                    whether independent or part of an agency, with tools that make
                    their work smarter, faster, and more efficient. As the insurance
                    industry evolves, PolicySaath strives to grow alongside agents and
                    support their long-term success.
                  </p>
                </div>
              </div>
              <EnquiryModal
                          show={showModal}
                          onClose={() => setShowModal(false)}
                        />
            </div>
          </div>
        </section>

      </div>

      {/* ... Footer is here ... */}
      <Footer />
    </>
  );
};

export default AboutUs;